import React, { useEffect, useMemo, useState } from 'react';
import { useClient } from 'jsonapi-react';
import { Modal } from '@/components/custom/modal/modal';
import { LiveChallengeResults } from '@/components/custom/live-challenge-results';
import { SectionState } from './SectionState';
import { mapRanking } from './reportApi';
import { formatDateTime, formatPercentage } from './formatters';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';

export function ClassificationModal({ show, onClose, challengeTitle, activation }) {
  const client = useClient();
  const playfulTeacher = usePlayfulTeacher();
  const [search, setSearch] = useState('');
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!show || !activation?.id) return undefined;

    let active = true;
    setLoading(true);
    setError(false);
    setSearch('');

    client
      .fetch(`/reports/live_challenges/activations/${activation.id}/ranking`)
      .then(({ data, error }) => {
        if (!active) return;
        if (error) {
          setError(true);
          setRanking([]);
        } else {
          setRanking(mapRanking(data.ranking));
        }
      })
      .catch(() => {
        if (active) {
          setError(true);
          setRanking([]);
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [show, activation?.id, client, reloadKey]);

  const filteredRanking = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return ranking;
    return ranking.filter(student => student.name.toLowerCase().includes(term) || student.email.toLowerCase().includes(term));
  }, [ranking, search]);

  const statCards = [
    { primary: challengeTitle, secondary: 'Desafio' },
    { primary: `Ativação ${activation?.label ?? ''}`, secondary: formatDateTime(activation?.date) },
    { primary: activation?.participants, secondary: 'Participantes' },
    { primary: formatPercentage(activation?.accuracyPercent), secondary: 'De acerto' }
  ];

  return (
    <Modal
      show={show}
      onClose={onClose}
      contentClassName="modal__content--xl"
    >
      <div className="flex min-w-0 flex-col gap-5">
        <h3 className="modal__dialog-title mb-0 text-left text-2xl">Classificação</h3>

        <SectionState
          loading={loading}
          error={error}
          onRetry={() => setReloadKey(key => key + 1)}
          errorTitle="Não foi possível carregar a classificação"
        >
          <LiveChallengeResults
            playfulTeacher={playfulTeacher}
            statCards={statCards}
            search={search}
            onSearchChange={setSearch}
            ranking={filteredRanking}
            emptyText="Nenhum aluno encontrado"
          />
        </SectionState>
      </div>
    </Modal>
  );
}
